<wr-base-dialog status="primary" header="Share Link">

  @if (inspectionPdf()?.pdfShareLink?.id) {
    <nb-alert>
      <div class="info-alert">
        <nb-icon icon="info-outline" pack="eva"></nb-icon>
        <span>Beim Generieren werden alte Links nicht verändert!</span>
      </div>
    </nb-alert>
  }

  <div [nbSpinner]="loading()">
    <div class="flex-container">
      <div class="duration-container">
        <label for="duration-select">Dauer auswählen:</label>

        <nb-select id="duration-select" [(selected)]="selectedDuration">
          @for (duration of durations; track duration) {
            <nb-option [value]="duration">{{duration}} Tage</nb-option>
          }
        </nb-select>
      </div>

      <div>
        <button
          (click)="generateShareLink()"
          nbButton
          status="basic"
          nbTooltip="Generiere Share Link">
          GENERIERE SHARE LINK
        </button>
      </div>
    </div>

    @if (inspectionPdf(); as pdf) {
      @if (pdf.pdfShareLink?.id && pdf.pdfShareLink?.expiration) {
        <div class="link-container">
          <div class="share-link">
            <label for="share-link">Share Link:</label>
            <input nbInput fullWidth id="share-link" type="text" [value]="shareLink()" readonly>
          </div>

          <nb-button-group class="button-group">
            <button nbButton status="primary" (click)="copyToClipboard(shareLink())" nbTooltip="Link kopieren">
              <nb-icon pack="eva" icon="copy-outline"></nb-icon>
            </button>
            <button nbButton status="primary" (click)="openLink(shareLink())" nbTooltip="Link öffnen">
              <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
            </button>
          </nb-button-group>
        </div>

        <div class="date-container">
          <p>Ablaufdatum: {{ pdf.pdfShareLink?.expiration | date: 'dd.MM.yyyy HH:mm' }}</p>
        </div>
      }
    }
  </div>
</wr-base-dialog>
